// ============================================
// TarjetaAvisosExternos.js — avisos a QUIEN AGENDO (CONTRATISTAS-EXTERNOS Bloque 3)
// ============================================
// En Mi dia: las personas de cuadrillas externas que RECHAZARON un trabajo (con su motivo) o que no contestaron en
// 24 h ("sin respuesta"). El hueco ya quedo libre; aqui se avisa para que quien agendo busque a otra persona.
// Solo lo ve quien tiene permiso de calendario (el servidor contesta 403 al resto y la tarjeta no se pinta).

import React, { useCallback, useEffect, useState } from 'react';
import { HardHat, Check } from 'lucide-react';
import { authHeaders } from '../utils/storage';
import { useUsuario } from '../context/UsuarioContext';
import { API_BASE } from '../config/api';

const PP = "'Poppins', sans-serif";
const fmt = (iso) => iso ? new Date(iso).toLocaleString('es-MX', { timeZone: 'America/Mexico_City', day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '';

export default function TarjetaAvisosExternos() {
  const { puede, accesoTotal, permisosFetched } = useUsuario();
  // Regla de oro de permisos: no se pide lo que no se puede ver (y asi no hay 403 en consola para el resto).
  const conPermiso = accesoTotal || (permisosFetched && puede('operaciones.calendario'));
  const [avisos, setAvisos] = useState([]);
  const cargar = useCallback(async () => {
    if (!conPermiso) { setAvisos([]); return; }
    try {
      const r = await fetch(`${API_BASE}/api/programaciones/avisos`, { headers: authHeaders() });
      if (!r.ok) { setAvisos([]); return; }
      const d = await r.json(); setAvisos(d.avisos || []);
    } catch { setAvisos([]); }
  }, [conPermiso]);
  useEffect(() => { cargar(); }, [cargar]);

  const visto = async (a) => {
    try { await fetch(`${API_BASE}/api/programaciones/avisos/${a.id}/visto`, { method: 'PATCH', headers: authHeaders() }); } catch {}
    setAvisos(prev => prev.filter(x => x.id !== a.id));
  };

  if (!avisos.length) return null;
  return (
    <div style={{ background: '#fff', border: '1px solid #f3c4c4', borderLeft: '4px solid #B42318', borderRadius: 12, padding: 14, marginBottom: 16, fontFamily: PP }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <HardHat size={18} color="#B42318" />
        <div style={{ fontSize: 14, fontWeight: 700, color: '#3D4248' }}>Cuadrillas externas: {avisos.length} {avisos.length === 1 ? 'hueco que quedó libre' : 'huecos que quedaron libres'}</div>
      </div>
      <div style={{ display: 'grid', gap: 6 }}>
        {avisos.map(a => (
          <div key={a.id} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: 13, color: '#3D4248', background: '#FBF8F8', borderRadius: 8, padding: '8px 10px' }}>
            <div style={{ flex: 1, minWidth: 0, lineHeight: 1.45 }}>
              <b>{a.persona}</b> <span style={{ color: '#5E666E' }}>({a.contratista})</span>{' '}
              {a.estado === 'rechazado' ? <>rechazó <b>{a.tipo}</b>{a.titulo ? ` "${a.titulo}"` : ''} del {fmt(a.fecha_inicio)}{a.motivo_rechazo ? <>: <i>"{a.motivo_rechazo}"</i></> : '.'}</> : <>no contestó en 24 h al <b>{a.tipo}</b> del {fmt(a.fecha_inicio)}.</>}
              {a.expediente_folio && <span style={{ color: '#5E666E' }}> · Expediente {a.expediente_folio}</span>}
            </div>
            <button type="button" onClick={() => visto(a)} title="Visto" aria-label="Marcar visto" style={{ flexShrink: 0, minHeight: 36, minWidth: 36, border: '1px solid #D7D9DB', background: '#fff', borderRadius: 8, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}><Check size={16} color="#1E7A4C" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
